<mat-card class="image-card" [routerLink]="['/models', image.userId]">
  <div class="image-container">
    <img [src]="image.firebaseUrl" [alt]="image.description || 'Image'" loading="lazy" />
  </div>
  <mat-card-content>
    <p class="image-description" *ngIf="image.description">{{ image.description }}</p>
    <p class="image-model" *ngIf="modelName">{{ modelName }}</p>
    <div class="image-stats">
      <span><mat-icon>favorite</mat-icon> {{ image.likesCount }}</span>
      <span><mat-icon>visibility</mat-icon> {{ image.viewsCount }}</span>
    </div>
  </mat-card-content>
</mat-card>
